import escapeStringRegexp from 'escape-string-regexp';
import { useMemo } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

import Label from './Label';

const SearchResultTag = (
  props: MatchedTagT & {
    searchString: string;
    isSelected: boolean;
    toggleItem: (alias: string) => void;
    focused: boolean;
  },
) => {
  const color = useColor();
  const matchedPathHTML = useMemo(() => {
    // converts special characters to regular expression
    const escapedSearchString = escapeStringRegexp(props.searchString);
    const re = new RegExp(escapedSearchString, 'gi');
    const matched = props.pathString?.match(re);
    const result =
      props.pathString?.replaceAll(re, `<strong>${matched}</strong>`) || '';
    return result;
  }, [props.pathString, props.searchString]);

  const matchedTagHTML = useMemo(() => {
    if (!props.tag.name) return '';
    // const re = new RegExp(props.searchString, 'gi');
    // const matched = props.tag.name.match(re);
    const result = props.tag.name.replaceAll(
      props.searchString,
      `<strong>${props.searchString}</strong>`,
    );
    return result;
  }, [props.tag.name, props.searchString]);
  return (
    <SearchResultTagStyle g="8px" a="center">
      {props.pathString && (
        <Typo type="label3" color={color.gray500}>
          <span
            dangerouslySetInnerHTML={{
              __html: matchedPathHTML,
            }}
          ></span>
        </Typo>
      )}
      <Label
        text={
          <span
            dangerouslySetInnerHTML={{
              __html: matchedTagHTML,
            }}
          ></span>
        }
        themeColor={props.tag.color}
        isSelected={props.isSelected}
        onClick={() => props.toggleItem(props.tag.alias)}
        focused={props.focused}
      />
    </SearchResultTagStyle>
  );
};

const SearchResultTagStyle = styled(Flex)`
  strong {
    font-weight: 900;
  }
`;

export default SearchResultTag;
